import React, { useEffect } from 'react';

const BookingCalendar = ({ unitId, categoryId, months = 12, defaultUnitId }) => {
  useEffect(() => {
    let cancelled = false;

    const loadJQuery = () => {
      return new Promise((resolve) => {
        if (window.jQuery) {
          resolve();
          return;
        }
        const script = document.createElement('script');
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.0/jquery.min.js';
        script.onload = resolve;
        document.head.appendChild(script);
      });
    };

    const loadCSS = () => {
      const existingLink = document.querySelector('link[href*="calendar-widget.css"]');
      if (!existingLink) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = 'https://milliesmotorhomehire.sb.anytimebooking.eu/widgets/calendar/css/calendar-widget.css';
        document.head.appendChild(link);
      }
    };

    const loadCalendarScript = () => {
      return new Promise((resolve) => {
        if (cancelled) return resolve();
        const host = document.getElementById('atb_anytime');
        if (host) host.querySelectorAll('.atb_calendar_container, #atb_selection-data').forEach((n) => n.remove());
        window.jQuery.getScript(
          'https://milliesmotorhomehire.sb.anytimebooking.eu/widgets/calendar/js/calendar.js',
          () => {
            if (defaultUnitId) preselectUnit(defaultUnitId);
            resolve();
          }
        );
      });
    };

    const preselectUnit = (id) => {
      let tries = 0;
      const timer = setInterval(() => {
        const sel = window.jQuery('#atb_unit_selection');
        if (sel.find(`option[value="${id}"]`).length) {
          sel.val(String(id)).trigger('change');
          clearInterval(timer);
        } else if (++tries > 40 || cancelled) {
          clearInterval(timer);
        }
      }, 250);
    };

    const initCalendar = async () => {
      await loadJQuery();
      loadCSS();
      setTimeout(async () => {
        await loadCalendarScript();
      }, 500);
    };

    initCalendar();

    return () => {
      cancelled = true;
    };
  }, [unitId, categoryId, months, defaultUnitId]);

  return (
    <div className="booking-calendar-wrapper" data-testid="booking-calendar">
      <p className="text-sm font-semibold text-slate-700 mb-1">{unitId ? 'Select your dates below:' : 'Step 1 - Choose your motorhome:'}</p>
      <div id="atb_calendar_container">
        <div 
          id="atb_anytime" 
          data-url="milliesmotorhomehire.sb" 
          data-category={categoryId}
          data-unit={unitId || undefined}
          data-months={months}
        >
          <span className="no-js">Loading live availability calendar...</span>
        </div>
      </div>
    </div>
  );
};

export default BookingCalendar;
